import completedDocumentLabel from './completedDocumentLabel.json'

interface KeywordLabel {
  /** formatId に含まれていたらこのラベルにする部分一致キー */
  keyword: string
  label: string
}

const DEFAULT_LABEL: string = completedDocumentLabel.default
const BY_FORMAT_ID: Record<string, string> = completedDocumentLabel.byFormatId
const BY_KEYWORD: KeywordLabel[] = completedDocumentLabel.byKeyword

/**
 * 完了画面の見出しに出す書類名。`rirekisho_*` のような派生 ID を個別に列挙しないため、
 * 完全一致 → 部分一致 → 既定（履歴書）の順で解決する。
 */
export function resolveCompletedDocumentLabel(formatId: string): string {
  if (!formatId) return DEFAULT_LABEL
  const exact = BY_FORMAT_ID[formatId]
  if (exact) return exact
  const matched = BY_KEYWORD.find(function (entry) {
    return formatId.includes(entry.keyword)
  })
  return matched ? matched.label : DEFAULT_LABEL
}
